/**
 * Currency Flags Show Active Fix
 * Ensures the selected currency flag is visible in the dropdown
 */

(function() {
  'use strict';

  function showActiveCurrencyFlag() {
    // Get the current currency
    var currentCurrency = Currency.currentCurrency || window.Currency?.currentCurrency || localStorage.getItem('countrycodecooke');

    if (!currentCurrency) {
      // Try to get from select element
      var currencySelect = document.getElementById('currencies');
      if (currencySelect) {
        currentCurrency = currencySelect.value;
      }
    }

    if (currentCurrency) {
      // Hide all flags first
      var allFlags = document.querySelectorAll('.selected--currency-flag .country--flag');
      allFlags.forEach(function(flag) {
        flag.style.display = 'none';
      });

      // Show only the active currency flag
      var activeFlag = document.querySelector('.selected--currency-flag .' + currentCurrency);
      if (activeFlag) {
        activeFlag.style.display = 'inline-block';
      }

      // Also show in mobile menu if exists
      var mobileFlagContainer = document.querySelector('.bigwidth .selected--currency-flag');
      if (mobileFlagContainer) {
        var mobileFlags = mobileFlagContainer.querySelectorAll('.country--flag');
        mobileFlags.forEach(function(flag) {
          flag.style.display = 'none';
        });
        var mobileActiveFlag = mobileFlagContainer.querySelector('.' + currentCurrency);
        if (mobileActiveFlag) {
          mobileActiveFlag.style.display = 'inline-block';
        }
      }
    }
  }

  // Listen for currency changes
  function watchCurrencyChange() {
    // Watch for select changes
    var currencySelect = document.getElementById('currencies');
    if (currencySelect) {
      currencySelect.addEventListener('change', function() {
        setTimeout(showActiveCurrencyFlag, 100);
      });
    }

    // Watch for custom currency button clicks
    var currencyButtons = document.querySelectorAll('.js-currency-button');
    currencyButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        var currency = this.getAttribute('data-value');
        if (currency) {
          setTimeout(showActiveCurrencyFlag, 100);
        }
      });
    });

    // Watch for nice-select clicks
    var currencyDropdown = document.querySelector('.nice-select-1.currency-switcher');
    if (currencyDropdown) {
      currencyDropdown.addEventListener('click', function() {
        setTimeout(showActiveCurrencyFlag, 200);
      });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      showActiveCurrencyFlag();
      watchCurrencyChange();
    });
  } else {
    showActiveCurrencyFlag();
    watchCurrencyChange();
  }

  // Also try after full page load
  window.addEventListener('load', function() {
    setTimeout(showActiveCurrencyFlag, 500);
  });

  // Expose function globally for manual calls if needed
  window.showActiveCurrencyFlag = showActiveCurrencyFlag;

})();
